import { AbstractQuery } from 'src/models/query';

export class GetTheMailInvitationForTheMailQuery extends AbstractQuery {
	override readonly name = 'IFS_Desktop_Query_Queries_Mail_GetTheMailInvitationForTheMailQuery';
	override sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId });
		this.cacheable = false;
	}
}
